/**
 * @enum CARD_ELEMENT_TYPE
 * @type {{RECTANGLE: string, ADDRESS: string, TEXT: string, PHOTO: string, NO_PRINT: string, STICKER: string}}
 */
export const CARD_ELEMENT_TYPE = {
  ADDRESS: 'ADDRESS',
  NO_PRINT: 'NO_PRINT',
  PHOTO: 'PHOTO',
  RECTANGLE: 'RECTANGLE',
  STICKER: 'STICKER',
  TEXT: 'TEXT',
  BARCODE: 'BARCODE',
};

/**
 * @enum CARD_SIDE
 * @type {{FRONT: string, BACK: string}}
 */
export const CARD_SIDE = {
  FRONT: 'FRONT',
  BACK: 'BACK',
};

/**
 * @enum CARD_TYPE
 * @type {{FRONT: string, BACK: string}}
 */
export const CARD_TYPE = {
  USER_CARD: 'USER_CARD',
  SYSTEM_CARD: 'SYSTEM_CARD',
};

/**
 * @enum CARD_BORDER_TYPE
 * @type {{DOTTED: string, DASHED: string, SOLID: string}}
 */
export const CARD_BORDER_TYPE = {
  DASHED: 'DASHED',
  DOTTED: 'DOTTED',
  SOLID: 'SOLID',
};

/**
 * @enum ACCOUNT_CARD_STATUS
 * @type {{DRAFT: string, SHIPPED: string}}
 */
export const ACCOUNT_CARD_STATUS = {
  DRAFT: 'DRAFT',
  SHIPPED: 'SHIPPED',
};

/**
 * @enum ACCOUNT_CARD_TYPE
 * @type {{COLLAGE: string, AUTO_LAYOUT: string, WALDOGRAM: string}}
 */
export const ACCOUNT_CARD_TYPE = {
  WALDOGRAM: 'WALDOGRAM',
  COLLAGE: 'COLLAGE',
  AUTO_LAYOUT: 'AUTO_LAYOUT',
};

/**
 * @enum ORIENTATION
 * @type {{LANDSCAPE: string, PORTRAIT: string}}
 */
export const ORIENTATION = {
  PORTRAIT: 'PORTRAIT',
  LANDSCAPE: 'LANDSCAPE',
};

/**
 *
 * @enum PHOTO_TYPE
 * @type {{PHOTO: string, FOREGROUND: string, BACKGROUND: string}}
 */
export const PHOTO_TYPE = {
  PHOTO: 'PHOTO',
  FOREGROUND: 'FOREGROUND',
  BACKGROUND: 'BACKGROUND',
  LOGO: 'LOGO',
};

/**
 * Semantic markers a PRO can place on a photo CardElementConfiguration's
 * help_placeholder, telling the buyer-side configurators how to fill the slot.
 *
 * @enum CARD_ELEMENT_HELP_PLACEHOLDER
 * @type {{TEAM: string}}
 */
export const CARD_ELEMENT_HELP_PLACEHOLDER = {
  // An editable photo slot filled from the identity's group photos.
  TEAM: 'TEAM',
};

/**
 * Page layouts a native app (iOS / Android) can request through the
 * "layout" entry of the "native_features" query param.
 *
 * @enum NATIVE_APP_LAYOUT
 * @type {{EDGE_TO_EDGE: string}}
 */
export const NATIVE_APP_LAYOUT = {
  // The webview is full screen and draws under the status bar and home
  // indicator, so the page must respect the safe-area insets itself.
  EDGE_TO_EDGE: 'EDGE_TO_EDGE',
};
